module.exports = "/images/white-0.2.png?ce49b2abb18011a332710502a4b55488";